<template>
  <div>
    <template v-if="type === 'button'">
      <button @click="showDownloadDataUI" class="text-base font-semibold inline-flex items-center rounded-md border border-transparent bg-blue-500 px-3 py-1.5 text-base font-medium leading-4 text-white shadow-sm hover:text-blue-100 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">Download Results</button>
    </template>
    <template v-else>
      <button @click="showDownloadDataUI" class="text-gray-900 group flex w-full items-center px-2 py-2 text-gray-800 hover:bg-gray-200">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mr-3 w-5 h-5">
          <path stroke-linecap="round" stroke-linejoin="round" d="m9 13.5 3 3m0 0 3-3m-3 3v-6m1.06-4.19-2.12-2.12a1.5 1.5 0 0 0-1.061-.44H4.5A2.25 2.25 0 0 0 2.25 6v12a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V9a2.25 2.25 0 0 0-2.25-2.25h-5.379a1.5 1.5 0 0 1-1.06-.44Z" />
        </svg>
        Download Results
      </button>
    </template>
    <b-modal v-model="showModal" title="Download Data">
      <div v-if="loading">
        <vue-simple-spinner class="my-4" size="large" :speed="1.1" :line-size="7" message="Loading Data..." line-fg-color="orange"/>
      </div>
      <div v-else>
        <div v-if="step === 1">
          <!-- Step 1: Choose items -->
          <p class="text-xl mb-2">Select the shows that you would like to email or download.</p>
          <div class="pb-0.5 mb-0.5 border-b">
            <label class="text-lg font-semibold">
              <input type="checkbox" v-model="selectAll" @change="toggleSelectAll">
              {{ selectAll ? 'Deselect All' : 'Select All' }}
            </label>
          </div>
          <ul>
            <li v-for="(o, i) in options" :key="i">
              <label>
                <input type="checkbox" v-model="selectedOptions" :value="o.id">
                {{ o.name }}
              </label>
            </li>
          </ul>
          <div class="mt-3" v-if="selectedOptions.length">
            <!-- Your code for selecting multiple items goes here -->
            <button @click="completeStepOne" class="px-4 py-2 bg-blue-500 text-white rounded-md">Next</button>
          </div>
        </div>
        <div v-else-if="step === 4">
          <!-- Step 2: Choose fields -->
          <h3>Step 2: Choose Fields</h3>
          <p class="text-lg mb-2">Select the fields that you would like to include in the download.</p>
          <label>
            <input type="checkbox" v-model="selectAllFields" @change="toggleSelectAllFields">
            Select All
          </label>
          <div>
            <ul>
              <li v-for="(field, index) in fieldOptions" :key="index">
                <label>
                  <input type="checkbox" v-model="selectedFields" :value="field">
                  {{ field.header }}
                </label>
              </li>
            </ul>
          </div>
          <button @click="previousStep" class="px-4 py-2 bg-blue-500 text-white rounded-md">Previous</button>
          <button @click="nextStep" class="px-4 py-2 bg-blue-500 text-white rounded-md">Next</button>
        </div>
        <div v-else-if="step === 2">
          <button @click="previousStep" class="btn-link mb-2">Go Back</button>
          <!-- Step 3: Choose destination -->
          <p class="text-lg mb-2">Files:</p>
          <ul>
            <li v-for="(item, index) in workingData" :key="index">
              <p class="text-sm mt-0.5">{{ item.fileName }}</p>
            </li>
          </ul>
          <div v-if="sending">
            <vue-simple-spinner class="my-4" size="large" :speed="1.1" :line-size="7" message="Sending Results..." line-fg-color="orange"/>
          </div>
          <template v-else>
            <div class="mt-4" v-if="retrievedData.length > 1">
              <label>
                <input type="checkbox" v-model="createZip">
                Download files to a zip folder
              </label>
            </div>
            <div class="mt-2 flex justify-between ">
              <div class="space-x-3 flex">
                <button @click="downloadData" class="px-4 py-2 bg-green-500 text-white rounded-md">Download Files</button>
                <button v-if="event.event_settings.btrjla_sanctioned" @click="submitBTRJLAResults"  class="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-md">Email Results to BTRJLA</button>
                <!--<button @click="emailData" class="px-4 py-2 hover:bg-blue-500 text-blue-500 hover:text-white border border-blue-500 rounded-md">Email Files</button>
                <input v-model="emailToSend" type="email" placeholder="Email Address" class="px-2 py-1 border border-gray-300 rounded-md">-->
              </div>
            </div>
            <div class="mt-2" v-if="event.event_settings.btrjla_sanctioned">
              <p class="mt-1 text-sm font-medium text-gray-800">Note: Submitting results to BTRJLA will email the selected show results to <span class="font-black">points@btrjla.com.</span></p>
            </div>
            <div v-if="return_message" class="bg-green-100 border border-green-500 p-3 text-green-800 mt-4 rounded-md">
              <p class="text-xl">{{ return_message }}</p>
            </div>
          </template>
        </div>
      </div>
    </b-modal>
    <download-data ref="downloadData"/>
  </div>
</template>

<script>
import DownloadData from '@/components/DownloadData.vue'

export default {
  components: {
    DownloadData
  },
  props: {
    type: String,
    options: {
      type: Array,
      default: () => []
    },
    headers: {
      type: Array,
      default: () => []
    },
    retrieveData: {
      type: Function,
      default: () => {}
    },
    fileName: {
      type: String,
      default: 'download'
    }
  },
  data () {
    return {
      step: 1,
      showModal: false,
      selectAll: false,
      selectAllFields: false,
      selectedOptions: [],
      retrievedData: null,
      selectedFields: [],
      loading: false,
      sending: false,
      createZip: false,
      return_message: '',
      emailToSend: ''
    }
  },
  watch: {
    options: {
      immediate: true,
      handler (newOptions) {
        // Your code to handle changes in options goes here
        if (newOptions.length === 1) {
          this.step = 2
        } else {
          this.step = 1
        }
      }
    }
  },
  methods: {
    async completeStepOne () {
      if (this.retrieveData) {
        this.loading = true
        this.retrievedData = await this.retrieveData(this.selectedOptions)
        this.selectedOptions.forEach((s, i) => {
          let itemName = this.options.filter(o => o.id === s)[0].name.replaceAll(' ', '_').replaceAll('/', '_')
          this.$set(this.retrievedData[i], 'fileName', this.fileName.replaceAll('/', '_') + '_' + itemName)
        })
      }
      this.loading = false
      this.step = 2
      this.selectAllFields = true
      this.selectedFields = this.fieldOptions
    },
    showDownloadDataUI () {
      this.selectedOptions = []
      this.selectedFields = []
      this.returnedData = null
      this.selectAll = false
      this.selectAllFields = false

      if (this.options.length === 1) {
        this.step = 2
      } else {
        this.step = 1
      }

      this.showModal = true
    },
    nextStep () {
      if (this.step === 1 && this.options.length === 1) {
        this.step = 2
      } else {
        this.step++
      }
    },
    previousStep () {
      this.step--
    },
    toggleSelectAll () {
      if (this.selectAll) {
        this.selectedOptions = this.options.map(o => o.id)
      } else {
        this.selectedOptions = []
      }
    },
    toggleSelectAllFields () {
      if (this.selectAll) {
        this.selectedFields = this.fieldOptions
      } else {
        this.selectedFields = []
      }
    },
    downloadData () {
      if (this.retrievedData.length === 1) {
        this.$refs.downloadData.exportCSVFile(this.retrievedData[0].fileName.replaceAll('/', '_'), this.retrievedData[0].data, this.selectedFields, this.retrievedData[0].headerRow)
      } else {
        if (!this.createZip) {
          this.retrievedData.forEach((item, i) => {
            this.$refs.downloadData.exportCSVFile(item.fileName.replaceAll('/', '_'), item.data, this.selectedFields, item.headerRow)
          })
        } else {
          this.$refs.downloadData.exportZipFile(this.fileName.replaceAll('/', '_'), this.retrievedData, this.selectedFields)
        }
      }
      // this.$refs.downloadData.exportCSVFile(this.retrievedData[0].fileName, this.retrievedData[0].data, this.selectedFields)
    },
    emailData () {
      if (!this.emailToSend) {
        this.return_message = 'Please enter an email address'
        return
      }
      this.loading = true
      this.$refs.downloadData.emailData(this.retrievedData, this.selectedFields, false)
        .then(response => {
          this.return_message = `Results have been emailed to ${ this.emailToSend }`
          this.loading = false
        })
    },
    submitBTRJLAResults () {
      this.sending = true
      this.$refs.downloadData.emailData(this.retrievedData, this.selectedFields, true)
        .then(response => {
          this.return_message = 'Results have been emailed to the BTRJLA. You have been copied on the email they were sent.'
          setTimeout(() => {
            this.sending = false
          }, 2000)
        })
    }
  },
  computed: {
    event () {
      return this.$store.state.admin.adminData.event
    },
    workingData () {
      return this.retrievedData || {data: this.options, headers: this.headers}
    },
    fieldOptions () {
      let fields = []
      this.workingData.forEach(item => {
        item.headers.forEach(h => {
          if (!fields.filter(f => f.field === h.field).length) {
            fields.push(h)
          }
        })
      })

      return fields
    }
  }
}
</script>

<style scoped>
/* Your component styles go here */
</style>
